import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { AuthService } from './auth.service';
import { AccessType, UserAccess } from 'ops/common/models/access-settings';

@Injectable({ providedIn: 'root' })
export class TrendGraphAccessSettingsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private authService: AuthService,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getAll(trendGraphId): Promise<any> {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/trend-graph/access-settings`, {
                params: { trendGraphId },
            }),
        );
    }

    public create(usersAccess, trendGraphId: string): Promise<any> {
        const currentUserId = this.authService.getCurrentUserId();
        usersAccess.map((user: UserAccess) => {
            if (user.roleId === currentUserId) {
                user.accessLevel = AccessType.Owner;
            }
        });
        const body = {
            usersAccess,
            trendGraphId,
        };
        return lastValueFrom(
            this.http.post(`${this.domain}/api/trend-graph/access-settings`, body, {
                headers: this.headers,
            }),
        );
    }

    public update(updatedUsersAccess): Promise<any> {
        return lastValueFrom(
            this.http.put(`${this.domain}/api/trend-graph/access-settings/`, updatedUsersAccess, {
                headers: this.headers,
            }),
        );
    }

    public updatePageAccess(publicAccess: boolean, trendGraphId: string): Promise<any> {
        return lastValueFrom(
            this.http.put(
                `${this.domain}/api/trend-graph/access-settings/` + trendGraphId,
                { publicAccess },
                {
                    headers: this.headers,
                },
            ),
        );
    }
}
